import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { AppComponent } from "@irb/app.component";
import { importProvidersFrom } from '@angular/core';

if(location.hostname.startsWith("irebal.schwab")) {
  enableProdMode();
  if(window){
    window.console.log = function(){};
    window.console.warn = function(){};
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppModule)
  ]
}).catch(err => console.error(err));
